import { parseQuery } from '@calendly/http-tools'
import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

import { parseParams } from 'services/workflows/url'

import { NewWorkflowForm, EditWorkflowForm } from './builder'

const NewWorkflowFormComponent = ({ match }) => <NewWorkflowForm owner={parseParams(match).owner} />
const EditWorkflowFormComponent = ({ match }) => <EditWorkflowForm owner={parseParams(match).owner} uuid={match.params.uuid} />
const ShowWorkflowFormComponent = ({ match }) => {
  const { group_id: groupId } = parseQuery(window.location.search)
  const owner = groupId ? { type: 'user_group', id: groupId } : { type: 'organization' }

  return <EditWorkflowForm readOnly owner={owner} uuid={match.params.uuid} />
}

const WorkflowsTemplateGallery = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./template_gallery')).TemplateGallery })
  )
)

export const WorkflowsRoutes = ({ match }) => (
  <Switch>
    <Route
      path={`${match.url}/:owner_type/:owner_id/workflow_templates`}
      component={WorkflowsTemplateGallery}
    />
    <Route
      path={`${match.url}/:owner_type/:owner_id/workflows/new`}
      component={NewWorkflowFormComponent}
    />
    <Route
      path={`${match.url}/:owner_type/:owner_id/workflows/:uuid/edit`}
      component={EditWorkflowFormComponent}
    />
    <Route
      path={`${match.url}/organization/workflows/:uuid`}
      component={ShowWorkflowFormComponent}
    />
  </Switch>
)
